import { render } from "./AlertTestDialog.vue?vue&type=template&id=021b113d&scoped=true"
import script from "./AlertTestDialog.vue?vue&type=script&lang=js"
export * from "./AlertTestDialog.vue?vue&type=script&lang=js"

import "./AlertTestDialog.vue?vue&type=style&index=0&id=021b113d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b113d"]])

export default __exports__